import React from "react";
import { string } from "prop-types";

import WithSSO from "../../with-sso";

import "./notLoggedInView.m.css";

const NotLoggedInView = ({ authHost, redirectUrl, callbackUrl }) => (
  <div styleName="not-logged-view">
    <WithSSO
      ssoHost={authHost}
      signInPath="/sign-in-page"
      signUpPath="/sign-up-page"
      redirectUrl={redirectUrl}
      callbackUrl={callbackUrl}
    >
      {({ signInHref }) => (
        <a styleName="button" href={signInHref}>
          Click here to login
        </a>
      )}
    </WithSSO>
  </div>
);

NotLoggedInView.propTypes = {
  authHost: string,
  redirectUrl: string,
  callbackUrl: string,
};

export default NotLoggedInView;
